// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { QuestRoute } from '../../../_common/api/QuestRoutes';
import { Regex } from '../../../_common/api/regex';
import { currency, generateId } from '../../../_common/api/utility';
import Cart from '../../../_common/Cart';
import Button from '../../../_common/form/Button';
import Form from '../../../_common/form/Form';
import Input from '../../../_common/form/Input';
import Title from '../../../_common/form/Title';
import { useGlobalState } from '../../../_common/globalState/GlobalStateProvider';
import Modal from '../../../_common/Modal';
import LogIn from '../../LogIn';
import Loading from '../../../_common/Loading';
import { HamQuest } from '../../../../App';

const Row = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 1em;
`;
const Col = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;
const SmallText = styled.div`
    font-size: 0.5em;
`
const Price = styled.div`
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 2em;
    font-decoration: italic;
`


const Merchandise = () => {
    const {
        state: {
            active_user
        },
    } = useGlobalState();

    const [merch, setMerch] = useState(null);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.merchandise)
            .then((res) => setMerch(res))
    }, [])

    return (
        <div>
            {
                merch ?
                    <>
                        <Title>Merchandise</Title>
                        {
                            merch
                                .sort((a, b) => b.price - a.price)
                                .map(e =>
                                    <Row key={generateId()}>
                                        <Col>
                                            <div>{e.name}</div>
                                            <div>{e.details.join('')}</div>
                                        </Col>
                                        <Col>
                                            <Price><SmallText>$</SmallText>{e.price}</Price>
                                            {active_user.isLoggedIn && <Button onClick={() => Cart.BuyNow(e)}>Buy Now</Button>}
                                            {Cart.AddButton(e)}
                                        </Col>
                                    </Row>
                                )
                        }
                    </>
                    : <Loading />
            }
        </div>
    )
}

export default Merchandise;